import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EcitationUserService {

  url = environment.apiUrl


  private reloadComponent1Subject = new Subject<void>();
  reloadComponent1$ = this.reloadComponent1Subject.asObservable();

  reloadComponent1(){
    this.reloadComponent1Subject.next();
  }
  
  constructor(private http:HttpClient) { }


allUserType(){

  return this.http.get(this.url+'/ecitation-services/allUserTypeCds')
}
getMuniStatus(){
  
   return this.http.get(this.url+`/ecitation-services/muniStatus`)
 }
 getMuniQueueSummary(params:any){
  
   return this.http.get(this.url+`/ecitation-services/muniQueueSummary?${params}`)
 }
 getMuniQueueDetails(courtNumber:any){
 
   return this.http.get(this.url+`/ecitation-services/muniQueueSummaryDetails?${courtNumber}`)
 }
 purgeRecords(pData:any){
  
   return this.http.post(this.url+`/ecitation-services/deleteCitation`,pData)
 }

allUserRoles(){
 
  return this.http.get(this.url+'/ecitation-services/allUserRoles')
}

getAgencyList(userType:string){
 
  return this.http.get(this.url+`/ecitation-services/${userType}`)
}

getAllUsersDetails(){
 
  return this.http.get(this.url+'/ecitation-services/allUsers')
}


unlockUser(userName:any,loggedInUserName:any){
  let body = new HttpParams();
  body = body.set('userName',userName)
  body = body.set('loggedInUserName',loggedInUserName)
  return this.http.post(this.url+'/ecitation-services/unlock?', {}, {params :body})
}

enableDisableUser(userName:any,loggedInUserName:any){
  let body = new HttpParams();
  body = body.set('userName',userName)
  body = body.set('loggedInUserName',loggedInUserName)
  return this.http.post(this.url+'/ecitation-services/enableOrDisable?', {}, {params :body})
}
  
addNewUser(userData:any){
    return this.http.post(this.url+"/ecitation-services/saveUser",userData)
  }
}
